import styled from 'styled-components';

export const ToggleButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  width: auto;

  @media (max-width: 500px) {
    width: 100%;
    max-width: 600px;
    flex-wrap: wrap;
    margin: 10px;
  }
`;

export const ToggleButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  font-family: var(--poppins);
  border-radius: 25px;
  border: 2px solid transparent;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 16px;
  }

  @media (max-width: 500px) {
    flex: 1 1 calc(50% - 0.5rem);
    min-width: 120px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 6px 12px;
  }

  &.selected {
    background-color: #dc1e45;
    color: #fff;
  }

  &.error {
    border-color: #dc1e45;
  }
`;
